import {Direction} from "@core/bean/direction";

export class Sort {

  SORT_DESC = 'descend';
  SORT_ASC = 'ascend';

  name: string;
  direction: Direction;

  constructor(name:string,direction:Direction){
    this.name=name;
    this.direction=direction;
  }

  toString(){
    let str=this.name+','+Direction[this.direction];
    return str;
  }

  static parse(sortStr:string):Sort{
    let name=sortStr.split(' ')[0];
    let direction=sortStr.split(' ')[1];
    direction=direction.toLowerCase();
    if(direction=='asc' || direction=='ascend'){
        return new Sort(name,Direction.ASC);
    }else{
      return new Sort(name,Direction.DESC);
    }
  }

  getDirectionString(): string {
    if (this.direction == Direction.ASC) {
      return this.SORT_ASC;
    } else if (this.direction == Direction.DESC) {
      return this.SORT_DESC;
    } else {
      return null;
    }

  }

}


